import {
    TOUR_OPERATOR_REVIEW_DETAIL_START,
    TOUR_OPERATOR_REVIEW_DETAIL_SUCCESS,
    TOUR_OPERATOR_REVIEW_DETAIL_ERROR,
} from "../Constant/TourRatingReviewsConstant"

const initialState = {
    loading: false,
    tourRatingReviewsdata:[]
}

export default function TourRatingReviewsReducer(
    state = { ...initialState},
    action
) {
    switch (action.type) {   
            case TOUR_OPERATOR_REVIEW_DETAIL_START:
                    return {
                        ...state,
                        loading: true,
                    };
            case TOUR_OPERATOR_REVIEW_DETAIL_SUCCESS:
                    return {
                        ...state,
                        tourRatingReviewsdata: action.payload,
                        loading: false,
                    };
            case TOUR_OPERATOR_REVIEW_DETAIL_ERROR:
                    return {
                        ...state,
                        loading: false,
                        message: action.error.message,
                    };
               default:
                   return state;
    }
}